import React from "react";
import DefaultCard from "./default-card";

import ucaEnv from "../../../../common/env/env-uca";
import { useApi } from "../../../../hooks";
import { CommonModule } from "uca-react-containers-library";

const getCategoryLabel = (status) => {
  switch (status) {
    case "CREATED":
      return "Modify Order";
    case "CREATED-AFTER-CUTOFF":
    case "IN-PROGRESS":
    case "PICK-START":
    case "PACKED":
    case "ENROUTE-TO-PICKUP":
    case "BEHIND-SCHEDULE":
    case "PENDING_RESCHEDULED":
      return "View Order";
    case "DELIVERY-ON-THE-WAY":
      return "Track Order";
    case "DELIVERED ":
    case "PICKED-UP ":
      return "Report an issue";
    case "DELIVERY-MISSED":
      return "Reschedule order";
    case "CANCELLED":
      return "View order history";
    case "TENDER-DECLINE ":
      return "Update info";
    default:
      return "View order history";
  }
};

const OrderCard = ({ category, banner, isGuest }) => {
  let apiResponse;
  if (!isGuest) {
    const {
      appData: { env, platform },
    } = CommonModule.useApp();
    const environmentVariables = ucaEnv(banner, env, platform);
    const { data } = useApi(
      `${environmentVariables.REWARDS_PAGE_BASE_API}/customer/orders`
    );
    apiResponse = (data && data.orders && data.orders[0]) || null;
  }

  const link = {
    label: "View all orders",
    href: isGuest && !apiResponse ? "/account/sign-in.html" : "/help/orders",
    defaultUrl: "/help/orders",
  };

  return (
    <DefaultCard
      category={{
        ...category,
        title:
          !isGuest && apiResponse
            ? apiResponse && apiResponse.status
            : "My Orders",
        desc:
          !isGuest && apiResponse
            ? apiResponse && apiResponse.message
            : category.desc,
        link,
      }}
      showLink
    />
  );
};

export default OrderCard;
